import {
  GET_DOCUMENT_DETAIL_INIT,
  GET_DOCUMENT_DETAIL_SUCCESS,
  GET_DOCUMENT_DETAIL_FAILED,
  UPLOAD_DOCUMENT_INIT,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAILED,
  UPDATE_DOCUMENT_STATUS_INIT,
  UPDATE_DOCUMENT_STATUS_SUCCESS,
  UPDATE_DOCUMENT_STATUS_FAILED,
} from "./constants";
export const initialState = {
  loading: false,
  updatedDocType: null,
  documentTypes: [],
  allDocuments: [],
};

export default function documentDetail(state = initialState, action) {
  switch (action.type) {
    case GET_DOCUMENT_DETAIL_INIT:
      return { ...state, loading: true };
    case GET_DOCUMENT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        allDocuments: action.payload,
      };
    case GET_DOCUMENT_DETAIL_FAILED:
      return { ...state, loading: false };
    case UPLOAD_DOCUMENT_INIT:
      return { ...state, loading: true, updatedDocType: action.typeId };
    case UPLOAD_DOCUMENT_SUCCESS:
      const { typeId, payload } = action;
      const { allDocuments } = state;
      const filterdDocIndex = state.allDocuments.findIndex(
        (d) => d.key === typeId
      );
      const filterdDoc = allDocuments[filterdDocIndex];
      const updatedDoc = Object.assign({}, filterdDoc, {
        document:
          filterdDoc.document !== null
            ? Object.assign({}, filterdDoc.document, payload)
            : payload,
      });
      return {
        ...state,
        loading: false,
        updatedDocType: null,
        allDocuments: [
          ...allDocuments.slice(0, filterdDocIndex),
          updatedDoc,
          ...allDocuments.slice(filterdDocIndex + 1, allDocuments.length),
        ],
      };
    case UPLOAD_DOCUMENT_FAILED:
      return { ...state, loading: false, updatedDocType: null };
    case UPDATE_DOCUMENT_STATUS_INIT:
      return { ...state, loading: true };
    case UPDATE_DOCUMENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        documentTypes: action.payload,
      };
    case UPDATE_DOCUMENT_STATUS_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
